module.exports = __webpack_public_path__ + "img/the_gum_song.006b550c.jpg";